module.exports = __webpack_public_path__ + "media/step4_animation_Brueche.90939b62.mp4";